import { CreateReservationRequestDto } from '../types/reservation';
import { User } from '../types/user';

type BuildParams = {
  equipmentId: string | number;
  startDate: Date | string;
  endDate: Date | string;
  shippingAddress: string;
  user?: User | null;
  province?: string;
  city?: string;
  cp?: string;
  notes?: string | null;
  discountApplied?: number | null;
  insuranceIncluded?: boolean;
};

export function buildCreateReservationDto({
  equipmentId,
  startDate,
  endDate,
  shippingAddress,
  user,
  province,
  city,
  cp,
  notes = null,
  discountApplied,
  insuranceIncluded = true,
}: BuildParams): CreateReservationRequestDto {
  const toYmd = (d: Date) => d.toISOString().slice(0, 10);

  const userProvince = user && 'province' in user ? (user as unknown as Record<string, string>).province || '' : '';
  const userCity = user && 'city' in user ? (user as unknown as Record<string, string>).city || '' : '';
  const userCp = user && 'cp' in user ? (user as unknown as Record<string, string>).cp : undefined;

  const cpFromAddress = (() => {
    const match = (shippingAddress || '').match(/\b(\d{4,5})\b/);
    return match ? match[1] : '';
  })();

  const finalProvince = province ?? userProvince ?? '';
  const finalCity = city ?? userCity ?? '';
  const finalCp = cp ?? userCp ?? cpFromAddress ?? '';

  const parseToYmd = (v: Date | string) => (typeof v === 'string' ? v : toYmd(v));

  return {
    equipmentId: String(equipmentId),
    startDate: parseToYmd(startDate),
    endDate: parseToYmd(endDate),
  shippingAddress: shippingAddress || (user && (user as unknown as Record<string, unknown>).shippingAddress as string) || '',
    province: finalProvince,
    city: finalCity,
    cp: finalCp,
    notes,
    discountApplied: discountApplied ?? undefined,
    insuranceIncluded: insuranceIncluded ?? false,
  };
}
